import { z } from 'zod';

export const IssuerSchema = z.object({
  legalName: z.string().min(1),
  nif: z.string().min(1),
  address: z.string().nullish(),
  city: z.string().nullish(),
  postalCode: z.string().nullish(),
  country: z.string().nullish(),
  iban: z.string().nullish(),
  billingEmail: z.string().email().nullish(),
  companyName: z.string().nullish(),
});
export type IssuerInput = z.infer<typeof IssuerSchema>;
